import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';

const CONTENT_CLS =
  'font-body text-base leading-relaxed text-muted-foreground' +
  ' [&_h1]:font-heading [&_h1]:text-xl sm:[&_h1]:text-2xl [&_h1]:font-normal' +
  ' [&_h1]:text-foreground [&_h1]:mb-4 [&_h1]:italic [&_h1]:mt-10' +
  ' [&_h1:first-child]:mt-0' +
  ' [&_p]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_li]:mb-1' +
  ' [&_a]:text-primary [&_a]:underline';

const DEFAULT_BODY = '<h1>Fair Housing</h1><p>We are pledged to the letter and spirit of U.S. policy for the achievement of equal housing opportunity throughout the Nation. We encourage and support an affirmative advertising and marketing program in which there are no barriers to obtaining housing because of race, color, religion, sex, disability, familial status, or national origin.</p><h1>Our Commitment</h1><p>In accordance with the Fair Housing Act, we do not discriminate against any person in the rental of housing, or in the provision of services or facilities, because of race, color, religion, sex, disability, familial status, or national origin. We also comply with all applicable state and local fair housing laws.</p><h1>Questions</h1><p>If you have questions about our fair housing practices, please <a href="/contact-us">contact us</a>. You may also contact the U.S. Department of Housing and Urban Development (HUD) for information about fair housing rights.</p>';

export function FairHousingContent() {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <RichTextContent
          path="fairhousingcontent.body"
          defaultValue={DEFAULT_BODY}
          as="div"
          className={CONTENT_CLS}
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FairHousingContent',
  displayName: 'Fair Housing Content',
  tokens: {
    'fairhousingcontent.body': {
      label: 'Fair Housing Content',
      type: 'richtext',
      defaultValue: '<h1>Fair Housing</h1><p>We are pledged to the letter and spirit of U.S. policy for the achievement of equal housing opportunity throughout the Nation. We encourage and support an affirmative advertising and marketing program in which there are no barriers to obtaining housing because of race, color, religion, sex, disability, familial status, or national origin.</p><h1>Our Commitment</h1><p>In accordance with the Fair Housing Act, we do not discriminate against any person in the rental of housing, or in the provision of services or facilities, because of race, color, religion, sex, disability, familial status, or national origin. We also comply with all applicable state and local fair housing laws.</p><h1>Questions</h1><p>If you have questions about our fair housing practices, please <a href="/contact-us">contact us</a>. You may also contact the U.S. Department of Housing and Urban Development (HUD) for information about fair housing rights.</p>',
    },
  },
};

(FairHousingContent as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default FairHousingContent;
